import React, { useState } from 'react';

import { fetchPost as Post } from '@epi-helpers/FetchHelpers';
import { topupBenefitPending } from '@epi-api/topupLoad';
import { FormFields } from '@epi-forms/helpers';
import { useFormContext } from 'react-hook-form';

export const useTopupPendingBenefits = topupBeneficiariesIds => {
  const [isPendingBenefit, setIsPendingBenefit] = useState(false);
  const { watch } = useFormContext();

  const benefitType = watch(FormFields.Benefit);

  const getPendingBenefits = async () => {
    const payload = {
      beneficiaryIds: topupBeneficiariesIds,
      benefitType
    };

    const onSuccess = res => {
      setIsPendingBenefit(res.isTopUpLoadInProgress);
    };
    const onFailure = () => setIsPendingBenefit(false);

    Post(topupBenefitPending, payload, onSuccess).catch(onFailure);
  };

  return { isPendingBenefit, getPendingBenefits };
};
